var _path, _path2, _path3, _path4, _circle, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvents(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3247 18.3518H3.32471C2.22014 18.3518 1.32471 19.2472 1.32471 20.3518V34.3518C1.32471 35.4563 2.22014 36.3518 3.32471 36.3518H17.3247C18.4293 36.3518 19.3247 35.4563 19.3247 34.3518V20.3518C19.3247 19.2472 18.4293 18.3518 17.3247 18.3518Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3247 16.3518V20.3518",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32471 16.3518V20.3518",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32471 24.3518H19.3247",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.2376,
    cy: 11.9556,
    r: 8.96859,
    fill: "#FFD600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6547 9.22078C25.7147 8.29078 26.0697 7.56578 26.7197 7.04578C27.3797 6.52578 28.2197 6.26578 29.2397 6.26578C29.9397 6.26578 30.5447 6.39078 31.0547 6.64078C31.5647 6.89078 31.9497 7.23078 32.2097 7.66078C32.4697 8.09078 32.5997 8.57578 32.5997 9.11578C32.5997 9.73578 32.4347 10.2658 32.1047 10.7058C31.7747 11.1458 31.3797 11.4408 30.9197 11.5908V11.6508C31.5097 11.8308 31.9697 12.1608 32.2997 12.6408C32.6297 13.1108 32.7947 13.7158 32.7947 14.4558C32.7947 15.0458 32.6597 15.5708 32.3897 16.0308C32.1197 16.4908 31.7197 16.8558 31.1897 17.1258C30.6597 17.3858 30.0247 17.5158 29.2847 17.5158C28.2047 17.5158 27.3147 17.2408 26.6147 16.6908C25.9247 16.1308 25.5547 15.3308 25.5047 14.2908H27.1547C27.1947 14.8208 27.3997 15.2558 27.7697 15.5958C28.1397 15.9258 28.6397 16.0908 29.2697 16.0908C29.8797 16.0908 30.3497 15.9258 30.6797 15.5958C31.0097 15.2558 31.1747 14.8208 31.1747 14.2908C31.1747 13.5908 30.9497 13.0958 30.4997 12.8058C30.0597 12.5058 29.3797 12.3558 28.4597 12.3558H28.0697V10.9458H28.4747C29.2847 10.9358 29.8997 10.8008 30.3197 10.5408C30.7497 10.2808 30.9647 9.87078 30.9647 9.31078C30.9647 8.83078 30.8097 8.45078 30.4997 8.17078C30.1897 7.88078 29.7497 7.73578 29.1797 7.73578C28.6197 7.73578 28.1847 7.88078 27.8747 8.17078C27.5647 8.45078 27.3797 8.80078 27.3197 9.22078H25.6547Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvents);
export default __webpack_public_path__ + "static/media/events.3e6bb703e059bc4f26354643f1edc3a2.svg";
export { ForwardRef as ReactComponent };